import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { PagerLocation } from '../feed-grid/pager-location.model';
import { FeedGridService } from '../shared/feed-grid.service';

@Component({
    selector: 'dm-feed',
    templateUrl: './feed.component.html',
    styleUrls: ['./feed.component.css'],
    providers: [FeedGridService]
})
export class FeedComponent implements OnInit    {
    title: string;
    pagerLocation: PagerLocation = PagerLocation.Bottom;

    constructor(private gridService: FeedGridService, private windowTitle: Title) { }

    ngOnInit(): void {
        this.gridService.metadataDetailObservable.subscribe(
            detail => {
                this.title = detail.displayName;
                this.windowTitle.setTitle(`Data Miner 2 - ${detail.displayName}`);
            }
        );
    }

    closeWindow(): void {
        window.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/main/feeds/feed/feed.component.ts